
const ContractMain = () => import('@/app/views/parkings/views/parking-product-new/ContractMain');
const ContractCity = () => import('@/app/views/parkings/views/parking-product-new/ContractCity');
const ContractParking = () => import('@/app/views/parkings/views/parking-product-new/ContractParking');
const ContractPlan = () => import('@/app/views/parkings/views/parking-product-new/ContractPlan');
const ContractFechas = () => import('@/app/views/parkings/views/parking-product-new/ContractFechas');
const ContractResumen = () => import('@/app/views/parkings/views/parking-product-new/ContractResumen');
const ContractPayment = () => import('@/app/views/parkings/views/parking-product-new/ContractPayment');
const ContractSuccess = () => import('@/app/views/parkings/views/parking-product-new/ContractSuccess');

const DetalleParking = () => import('@/app/views/parkings/views/DetalleParking');
const DetalleParking1 = () => import('@/app/views/parkings/views/DetalleParking1');

const DetallePlan = () => import('@/app/views/parkings/views/parking-plan-form//DetallePlan');
const DetallePlanFechas = () => import('@/app/views/parkings/views/parking-plan-form/DetallePlanFechas');
const DetallePlanResumen = () => import('@/app/views/parkings/views/parking-plan-form/DetallePlanResumen');
const DetallePlanPayment = () => import('@/app/views/parkings/views/parking-plan-form/DetallePlanPayment');
const DetallePlanSuccess = () => import('@/app/views/parkings/views/parking-plan-form/DetallePlanSuccess');

const Search = () => import("@/app/views/buscador/views/MainParkings");


const parkingRoutes = [
  {
    path: "parkings",
    redirect: "/parkings",  ///nuevo-plan
    name: "Parkings",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Buscador de Parkings",
        component: Search,
        meta: {
          auth: true
        }
      },


      {
        path: '/parkings',
        name: '',
        component: DetalleParking1,
        meta: {
          auth: true
        },
        children: [
          {
            path: '/parkings/test/:id', // slug-id
            name: 'Detalle',
            meta: {
              auth: true
            }
          }
        ]
      },



      {
        path: '/parkings',
        name: '',
        // component: DetalleParking,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        meta: {
          auth: true
        },
        children: [
          {
            path: '/parkings/:id', // slug-id
            name: 'Detalle Parking',
            // component: DetalleParking,
            component: {
              render(c) {
                return c("router-view");
              }
            },
            redirect: '/parkings/:id',
            meta: {
              auth: true
            },
            children: [
              {
                path: '/parkings/:id', // slug-id
                name: '',
                component: DetalleParking,
                meta: {
                  auth: true
                },
              },
              {
                path: '/parkings/:id/planes/:planId',
                name: 'Plan',
                component: DetallePlan,
                redirect: "/parkings/:id/planes/:planId/fechas",
                meta: {
                  auth: true
                },
                children:[
                  {
                    path: "fechas",
                    component: DetallePlanFechas,
                    meta: {
                      auth: true
                    },
                  },
                  {
                    path: "resumen", ///:id
                    component: DetallePlanResumen,
                    meta: {
                      auth: true
                    },
                  },
                  {
                    path: "pasarela", ///:id
                    component: DetallePlanPayment,
                    meta: {
                      auth: true
                    },
                  },
                  {
                    path: "finalizado", ///:id
                    component: DetallePlanSuccess,
                    meta: {
                      auth: true
                    },
                  },

                ]
              },
            ]
          },

        ]
      },

      {
        path:'/parkings/form/nuevo-plan',
        component: ContractMain,
        redirect: "/parkings/form/nuevo-plan/ciudad",
        meta: {
          auth: true
        },
        children:[
          {
            path: "ciudad",
            component: ContractCity,
            meta: {
              auth: true
            },
          },
          {
            path: "parking",
            component: ContractParking,
            meta: {
              auth: true
            },
          },
          {
            path: "plan",
            component: ContractPlan,
            meta: {
              auth: true
            },
          },
          {
            path: "fechas",
            component: ContractFechas,
            meta: {
              auth: true
            },
          },
          {
            path: "resumen", ///:id
            component: ContractResumen,
            meta: {
              auth: true
            },
          },
          {
            path: "pasarela", ///:id
            component: ContractPayment,
            meta: {
              auth: true
            },
          },
          {
            path: "finalizado", ///:id
            component: ContractSuccess,
            meta: {
              auth: true
            },
          },

        ]
      },


      // {
      //   path: '/parkings/:id',
      //   name: 'Detalle Parking',
      //   component: DetalleParking,
      //   meta: {
      //     auth: true
      //   },
      //   children: [
      //     {
      //       path: '/parkings/:id/planes/:planId',
      //       name: 'Plan',
      //       component: DetallePlan,
      //       redirect: "/parkings/:id/planes/:planId/fechas",
      //       meta: {
      //         auth: true
      //       },
      //       children:[
      //         {
      //           path: "/parkings/:id/planes/:planId/fechas",
      //           component: DetallePlanFechas,
      //           meta: {
      //             auth: true
      //           },
      //         },
      //         {
      //           path: "/parkings/:id/planes/:planId/resumen", ///:id
      //           component: DetallePlanResumen,
      //           meta: {
      //             auth: true
      //           },
      //         },
      //         {
      //           path: "/parkings/:id/planes/:planId/pasarela", ///:id
      //           component: DetallePlanPayment,
      //           meta: {
      //             auth: true
      //           },
      //         },
      //         {
      //           path: "/parkings/:id/planes/:planId/finalizado", ///:id
      //           component: DetallePlanSuccess,
      //           meta: {
      //             auth: true
      //           },
      //         },

      //       ]
      //     },

      //   ]
      // },



      // path: '/parking/planes/:id',
      // name: 'Plan',
      // component: DetallePlan,
      // redirect: "/parking/planes/:id/fechas",


      // {
      //   path: '/parkings/:id/planes/:planId',
      //   name: 'Plan',
      //   component: DetallePlan,
      //   redirect: "/parkings/:id/planes/:planId/fechas",
      //   meta: {
      //     auth: true
      //   },
      //   children:[
      //     {
      //       path: "fechas",
      //       component: DetallePlanFechas,
      //       meta: {
      //         auth: true
      //       },
      //     },
      //     {
      //       path: "resumen", ///:id
      //       component: DetallePlanResumen,
      //       meta: {
      //         auth: true
      //       },
      //     },
      //     {
      //       path: "pasarela", ///:id
      //       component: DetallePlanPayment,
      //       meta: {
      //         auth: true
      //       },
      //     },
      //     {
      //       path: "finalizado", ///:id
      //       component: DetallePlanSuccess,
      //       meta: {
      //         auth: true
      //       },
      //     },

      //   ]
      // },

    ]
  },
];


export default parkingRoutes;
